import React from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';

import { Repository } from 'apps/repository';
import { BreadCrumbs } from 'apps/repository/views/breadCrumbs';
import { Readme } from 'apps/readme/index';

import { conf } from 'apps/project/config.yaml';

@withNamespaces()
@inject('clientStore', 'routerStore')
@observer
export class DirectoryPage extends React.Component {
  render() {
    const {
      clientStore,
      routerStore,
      params,
      projectManager,
      repoManager,
      t,
    } = this.props;
    const { project } = projectManager;

    let returnRoute = clientStore.spaceRoute.route;
    const routeParams = routerStore.params.toJSON();
    const basepath = routerStore.params.get('basepath');
    const basepathSegs = basepath ? basepath.split('/') : [];
    const projectRouteParams = routerStore.params.toJSON();
    const returnParams = projectRouteParams;
    delete projectRouteParams.basepath;

    if (basepathSegs.length > 1) {
      returnRoute = `${clientStore.spaceRoute.route}.files.directory`;
      const returnBasepath = basepathSegs
        .slice(0, basepathSegs.length - 1)
        .join('/');
      if (returnBasepath) {
        returnParams.basepath = returnBasepath;
      } else {
        delete returnParams.basepath;
      }
    }

    const breadCrumbs = (
      <BreadCrumbs
        basepathSegs={basepathSegs}
        routeParams={routeParams}
        projectRouteParams={projectRouteParams}
        repoManager={repoManager}
        content={project && project.content}
      />
    );

    if (project && repoManager.repository) {
      return (
        <React.Fragment>
          <Repository
            title={t(conf.sections[1])}
            crumbs={breadCrumbs}
            projectManager={projectManager}
            repoManager={repoManager}
            returnLink={Object.assign(
              {},
              { route: returnRoute },
              { params: returnParams },
            )}
          />
          {project && repoManager.repository ? (
            <Readme
              title={t(conf.sections[2])}
              params={params}
              insideFolder={true}
              repoManager={repoManager}
              project={project}
              last
            />
          ) : (
            <React.Fragment />
          )}
        </React.Fragment>
      );
    }
    if (project) {
      return (
        <React.Fragment>
          <Repository
            crumbs={breadCrumbs}
            projectManager={projectManager}
            repoManager={repoManager}
            returnLink={Object.assign(
              {},
              { route: returnRoute },
              { params: returnParams },
            )}
          />
        </React.Fragment>
      );
    }
    return null;
  }
}

DirectoryPage.propTypes = {
  routerStore: PropTypes.object,
  clientStore: PropTypes.object,
  params: PropTypes.object,
  project: PropTypes.object,
  projectManager: PropTypes.object,
  repoManager: PropTypes.object,
  t: PropTypes.func,
};
